import { useState } from 'react'

import { mockPrintFormsStore, PrintFormConfig } from '@features/print-forms'

import { useHandlers } from './useHandlers'

export const usePrintFormsConfig = () => {
  const [configs, setConfigs] = useState<PrintFormConfig[]>(() => mockPrintFormsStore.getAll())

  const { state, handlers } = useHandlers({ setConfigs })

  return {
    state: {
      ...state,
      configs,
    },
    handlers,
  }
}
